export var ACTION;
(function (ACTION) {
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["NAV_CONTACT_US"] = "NAV_CONTACT_US";
    ACTION["ON_LOAD"] = "ON_LOAD";
    ACTION["NAV_NEXT_ACTION"] = "NAV_NEXT_ACTION";
    ACTION["SUCCESS_ACTION"] = "SUCCESS_ACTION";
    ACTION["FAILURE_ACTION"] = "FAILURE_ACTION";
    ACTION["ON_MODAL_CLOSE_ACTION"] = "ON_MODAL_CLOSE_ACTION";
})(ACTION || (ACTION = {}));
